import { ReactElement, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useUser from "base/hooks/useUser";
import { DASHBOARD_URL } from "dashboard/constants";
import useSnackbar from "base/hooks/useSnackbar";

interface Props {
  children: ReactElement;
}

const AdminGuard = ({ children }: Props) => {
  const navigate = useNavigate();
  const { isAdmin } = useUser();
  const { showWarning } = useSnackbar();

  useEffect(() => {
    console.log("isAdmin");
    if (typeof isAdmin !== "undefined" && isAdmin === false) {
      showWarning("You are not admin. Redirecting to dashboard.");
      navigate(`/${DASHBOARD_URL}`);
    }
  }, [isAdmin]);

  return children;
};

export default AdminGuard;
